import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import { SET_USER_INFO } from '@/utils/constants'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: null,
  },
  getters: {
    checkPermission: state => id => _.indexOf(state.userInfo.auth, id) >= 0,
  },
  mutations: {
    [SET_USER_INFO]: (state, payload) => {
      state.userInfo = payload
    },
  },
})

export default store
